<template>
  <span>
    <a
      v-if="href"
      v-bind:href="href"
      target="_blank"
      v-on:click.self.stop="onClickLink"
    >
      {{ valueFormatted }}
      <b-tooltip v-if="isTruncated" ref="tooltip" v-bind="tooltipOption" />
    </a>
    <span v-else>
      {{ valueFormatted }}
    </span>
  </span>
</template>

<script>
import { useAttributeFormatter } from 'ifield-core-components'
import { useIsTruncated } from '@/composables/UseIsTruncated'

/**
 * ag-grid の cell にリンク属性を表示するレンダラー
 */
export default {
  name: 'AppAttributeLinkCellRenderer',
  setup() {
    const { formatURL } = useAttributeFormatter()
    const { truncTarget, isTruncated } = useIsTruncated()
    return { formatURL, truncTarget, isTruncated }
  },
  computed: {
    /**
     * フォーマット済み値
     * @type {string}
     */
    valueFormatted() {
      return this.params.valueFormatted
    },
    /**
     * リンク先HREF
     * @type {string}
     */
    href() {
      const value = this.params.value.value
      return value ? this.formatURL(value) : null
    },
    /**
     * ツールチップオプション
     * @type {Object}
     */
    tooltipOption() {
      return {
        // 必ず cell の中心基準で表示させるために親のラッパー要素を対象にする
        target: () => this.params.eGridCell,
        interactive: false,
        container: 'body',
        boundary: 'window',
        placement: 'bottom',
        customClass: 'ifield-tooltip',
        title: this.valueFormatted,
      }
    },
  },
  mounted() {
    // 自身の span 要素は overflow するコンテンツ要素なので省略を見るには親のラッパー要素を見る
    this.truncTarget = this.params.eGridCell
  },
  methods: {
    /**
     * リンククリック時のコールバック
     */
    onClickLink(e) {
      // ツールチップが表示された状態だと表示が残り続けるので強制的に消す
      e.target.blur()
    },
  },
}
</script>
